module.exports = __webpack_public_path__ + "img/avatar.36d1e576.png";